import { defineMessages } from 'react-intl';
export const messages = defineMessages({
    virtualMachinesPageHeader: {
        id: 'VirtualMachinesPageHeader',
        defaultMessage: 'My virtual machines',
        description: 'The page header for the student virtual machines page.',
    },
});
export default messages;
